import * as React from "react";
import URI from "urijs";
import { OrderedMap } from "immutable";
import Routes from "routing/Routes";
import { useGetAssetsCount } from "security-app/hooks/useAssetsAPI";
import NumberCard from "./NumberCard";
const HIGH_RISK_THRESHOLD = 75;
const assetsReplayLink = () => new URI(Routes.ALERTS.LIST).addQuery("page", 1).addQuery("layout_variant", "assets").toString();
const HIGH_RISK_FILTERS = OrderedMap({ risk_score_normalized: [`${HIGH_RISK_THRESHOLD}><`] });
function AssetsCounter() {
  const { loadingCount: loadingTotal, count: total } = useGetAssetsCount();
  const { loadingCount: loadingHighRisk, count: highRiskAssetsCount } = useGetAssetsCount(HIGH_RISK_FILTERS);
  return /* @__PURE__ */ React.createElement(
    NumberCard,
    {
      value: highRiskAssetsCount.toString(),
      label: "High Risk Assets",
      subLabel: `${total} total`,
      replayLink: assetsReplayLink(),
      loading: loadingTotal || loadingHighRisk
    }
  );
}
export default AssetsCounter;
